import { store } from "app/store";
import axios from "axios";
import { removeToken, setAccessToken } from "features/authUserSlice";
import { refreshToken } from "services/login";
import {
  getAccessTokenLocalStorage,
  setAccessTokenLocalStorage,
} from "utils/token";

export const API_URL = "https://api.creationbesties.com";

axios.defaults.baseURL = `${API_URL}/api/`;

axios.interceptors.request.use(
  async (config) => {
    const accessToken = getAccessTokenLocalStorage();
    if (accessToken) {
      config.headers.set("Authorization", `Bearer ${accessToken}`);
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const { status } = error.response || {};
    const originalRequest = error.config;
    const state = store.getState();
    const { refreshToken: rfToken } = state.authUser;
    const dispatch = store.dispatch;
    if (status === 401 && !originalRequest.url?.includes("refresh-token")) {
      try {
        const { data } = await refreshToken(rfToken);
        setAccessTokenLocalStorage(data.accessToken);
        await dispatch(setAccessToken({ accessToken: data.accessToken }));
        return await axios(originalRequest);
      } catch (refreshError) {
        dispatch(removeToken());
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);
